"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ClayCardWithUser = void 0;

var _button = require("@clayui/button");

var _dropDown = require("@clayui/drop-down");

var _form = require("@clayui/form");

var _icon = _interopRequireDefault(require("@clayui/icon"));

var _layout = _interopRequireDefault(require("@clayui/layout"));

var _sticker = _interopRequireDefault(require("@clayui/sticker"));

var _react = _interopRequireDefault(require("react"));

var _Card = _interopRequireDefault(require("./Card"));

var _excluded = ["aria-label", "actions", "checkboxProps", "description", "disabled", "dropDownTriggerProps", "href", "name", "onSelectChange", "selected", "spritemap", "stickerTitle", "selectableType", "radioProps", "userImageAlt", "userDisplayType", "userImageSrc", "userSymbol", "truncate"];

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var ClayCardWithUser = function ClayCardWithUser(_ref) {
  var ariaLabel = _ref['aria-label'],
      actions = _ref.actions,
      _ref$checkboxProps = _ref.checkboxProps,
      checkboxProps = _ref$checkboxProps === void 0 ? {} : _ref$checkboxProps,
      description = _ref.description,
      disabled = _ref.disabled,
      _ref$dropDownTriggerP = _ref.dropDownTriggerProps,
      dropDownTriggerProps = _ref$dropDownTriggerP === void 0 ? {
    'aria-label': 'More actions'
  } : _ref$dropDownTriggerP,
      href = _ref.href,
      name = _ref.name,
      onSelectChange = _ref.onSelectChange,
      _ref$selected = _ref.selected,
      selected = _ref$selected === void 0 ? false : _ref$selected,
      spritemap = _ref.spritemap,
      stickerTitle = _ref.stickerTitle,
      selectableType = _ref.selectableType,
      _ref$radioProps = _ref.radioProps,
      radioProps = _ref$radioProps === void 0 ? {
    name: '',
    value: ''
  } : _ref$radioProps,
      _ref$userImageAlt = _ref.userImageAlt,
      userImageAlt = _ref$userImageAlt === void 0 ? 'thumbnail' : _ref$userImageAlt,
      userDisplayType = _ref.userDisplayType,
      userImageSrc = _ref.userImageSrc,
      _ref$userSymbol = _ref.userSymbol,
      userSymbol = _ref$userSymbol === void 0 ? 'user' : _ref$userSymbol,
      _ref$truncate = _ref.truncate,
      truncate = _ref$truncate === void 0 ? true : _ref$truncate,
      otherProps = _objectWithoutProperties(_ref, _excluded);

  var content = /*#__PURE__*/_react.default.createElement("div", {
    className: "aspect-ratio-item-center-middle card-type-asset-icon"
  }, /*#__PURE__*/_react.default.createElement(_sticker.default, {
    className: "sticker-user-icon",
    displayType: userDisplayType,
    shape: "circle",
    title: stickerTitle
  }, userImageSrc && /*#__PURE__*/_react.default.createElement(_sticker.default.Image, {
    alt: userImageAlt,
    src: userImageSrc
  }), !userImageSrc && /*#__PURE__*/_react.default.createElement(_icon.default, {
    spritemap: spritemap,
    symbol: userSymbol
  })));

  return /*#__PURE__*/_react.default.createElement(_Card.default, _extends({}, otherProps, {
    active: selected,
    displayType: "user",
    selectable: !!onSelectChange
  }), /*#__PURE__*/_react.default.createElement(_Card.default.AspectRatio, {
    className: "card-item-first"
  }, onSelectChange && (selectableType === 'radio' ? /*#__PURE__*/_react.default.createElement(_form.ClayRadio, _extends({}, radioProps, {
    checked: selected,
    disabled: disabled,
    onChange: function onChange(_ref2) {
      var value = _ref2.target.value;
      return onSelectChange(value);
    }
  }), content) : /*#__PURE__*/_react.default.createElement(_form.ClayCheckbox, _extends({}, checkboxProps, {
    checked: selected,
    disabled: disabled,
    onChange: function onChange() {
      return onSelectChange(!selected);
    }
  }), content)), !onSelectChange && content), /*#__PURE__*/_react.default.createElement(_Card.default.Body, null, /*#__PURE__*/_react.default.createElement(_Card.default.Row, null, /*#__PURE__*/_react.default.createElement(_layout.default.ContentCol, {
    expand: true
  }, /*#__PURE__*/_react.default.createElement(_Card.default.Description, {
    "aria-label": ariaLabel !== null && ariaLabel !== void 0 ? ariaLabel : name,
    disabled: disabled,
    displayType: "title",
    href: href,
    truncate: truncate
  }, name), description && /*#__PURE__*/_react.default.createElement(_Card.default.Description, {
    displayType: "subtitle",
    truncate: truncate
  }, description)), actions && /*#__PURE__*/_react.default.createElement(_layout.default.ContentCol, null, /*#__PURE__*/_react.default.createElement(_dropDown.ClayDropDownWithItems, {
    items: actions,
    spritemap: spritemap,
    trigger: /*#__PURE__*/_react.default.createElement(_button.ClayButtonWithIcon, _extends({}, dropDownTriggerProps, {
      className: "component-action",
      disabled: disabled,
      displayType: "unstyled",
      spritemap: spritemap,
      symbol: "ellipsis-v"
    }))
  })))));
};

exports.ClayCardWithUser = ClayCardWithUser;